import React from 'react';
import DatasetCardItem from '../containers/DatasetCardItem';

const DatasetCardItems = ({
  items,
  onCheckBoxClick,
  showStatus,
  showTools,
  single,
}) => (
  items.map((item, index) => (
    <DatasetCardItem
      dataset={item}
      key={`datasets_card_item_${item.id}`}
      onCheckBoxClick={onCheckBoxClick}
      showStatus={showStatus}
      showTools={showTools}
      single={single}
      upward={index > 4}
    />
  ))
);

export default DatasetCardItems;
